export default __webpack_public_path__ + "assets/models/90170bc9f594f8fd6f31f687bff0fcda.glb";